export default __webpack_public_path__ + "static/media/honey1.f48a934e.webp";